import * as React from 'react';
import { Global, css } from '@emotion/react';
import Head from 'next/head';

/**
 * Why crossOrigin="anonymous" on the link preloads?
 * See https://github.com/w3c/preload/issues/32 & https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types/preload#cors-enabled_fetches
 * In short: for fonts it's a micro perf gain to set the default crossOrigin val
 */

/**
 * Load ZooplaDisplay with @font-face via @emotion/global and preload link via
 * next/head
 */
const ZooplaDisplayFontFamilyGlobals: React.FC = () => (
    <>
        <Global
            styles={css`
                @font-face {
                    font-family: 'ZooplaDisplay';
                    font-style: normal;
                    font-weight: bold;
                    font-display: swap;
                    src: local('ZooplaDisplay-Bold'),
                        url('/fonts/ZooplaDisplay-Bold.woff2') format('woff2'),
                        url('/fonts/ZooplaDisplay-Bold.woff') format('woff');
                }
            `}
        />
        <Head>
            <link
                rel="preload"
                as="font"
                href="/fonts/ZooplaDisplay-Bold.woff2"
                type="font/woff2"
                crossOrigin="anonymous"
            />
        </Head>
    </>
);

export { ZooplaDisplayFontFamilyGlobals };
